<template>
  <span class="sf-label" :class="pointerClass" @click="visitUrl">
    <i v-if="showTalkingPointsIcons" class="fa-solid fa-user-group" />
    <span :class="tagClass">{{ tag.name }}</span>
  </span>
</template>

<script setup lang="ts">
import type { RemarkTag } from '@app/shared/types/sf-data'
import { isFeatureSupported } from '@app/adapters/silverfin'
import { computed } from 'vue'
import { useNavigationStore } from '@app/shared/vue/store/navigation-store'

interface Props {
  tag: RemarkTag & { url?: string }
  disableLink?: boolean
}
const props = defineProps<Props>()

const supportsTalkingPoints = isFeatureSupported('supports_talking_points')

const navigationStore = useNavigationStore()

const showTalkingPointsIcons = computed(
  () => props.tag.talkingPoint && supportsTalkingPoints
)

const clickableLink = computed(
  () =>
    (showTalkingPointsIcons.value || !props.tag.talkingPoint) &&
    props.tag.url &&
    window.location.pathname !== props.tag.url &&
    !props.disableLink
)
const tagClass = computed(() => ({
  'tw-text-sf-primary': clickableLink.value,
}))

const pointerClass = computed(() => ({
  'tw-cursor-pointer hover:tw-bg-sf-gray-lighter': clickableLink.value,
}))

function visitUrl() {
  if (clickableLink.value && props.tag.url) {
    const location = window.location.href

    window.Turbolinks.visit(props.tag.url)

    navigationStore.enableBackInContext(location, 'remark_tag', '')
  }
}
</script>
